// Default booking strategy: passthrough of `site.reserveUrl`.
//
// Used when no per-agency strategy applies. The scanner has already written a
// fully-qualified URL into Site.reserveUrl, so we return it as-is. All inputs
// (arrivalDate, departureDate, ref, partySize) are ignored because they are
// not encoded into the URL by this strategy.

export default {
  buildBookingUrl({ site }) {
    return site.reserveUrl;
  },

  // Preview URL = link to a "what does this facility have?" page that the
  // request form's "View map" / "Need help choosing?" button points at.
  // Default: same as the scanner-written reserveUrl. Override per-agency
  // when the booking page redirects without dynamic params, when the
  // provider has a separate map endpoint, or when the agency has no
  // useful preview page (return null to hide the alert).
  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "ignored",
          notes:
            "This agency's reserveUrl is a static deep-link; arrival date is not encoded.",
        },
        departureDate: {
          status: "ignored",
          notes:
            "This agency's reserveUrl is a static deep-link; departure date is not encoded.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already identifies the site.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes: "Party size is not encoded in the passthrough URL.",
        },
      },
    };
  },
};
